// extracted by mini-css-extract-plugin
module.exports = {"kenniscentrumOfReleasenotes":"FilterInhoud_kenniscentrumOfReleasenotes__slQfp","active":"FilterInhoud_active__akfNR","nonActive":"FilterInhoud_nonActive___b8WI"};